'use client';

import styled from 'styled-components';

import { Flex } from '@zoomit/primitives';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

type PositionType = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

type Props = {
  position: PositionType;
};

const AdvertisingReportage = (props: Props) => {
  const { position } = props;

  return (
    <AdvertisingReportageWrapper position={position} justifyContent="center" alignItems="center">
      <Typography
        variant="subhead"
        textColor={cssVar(theme.white)}
        tag="div"
        lineHeight={1.6}
        fontWeight="bold"
      >
        Ad
      </Typography>
    </AdvertisingReportageWrapper>
  );
};

export default AdvertisingReportage;

type ReportagePositionType = {
  position: PositionType;
};

const AdvertisingReportageWrapper = styled(Flex)<ReportagePositionType>`
  background-color: var(${theme.grey5});
  width: 2rem;
  height: 1.6rem;
  position: absolute;
  top: ${({ position }) => (position === 'top-left' || position === 'top-right' ? '0' : 'unset')};
  right: ${({ position }) => (position === 'top-right' || position === 'bottom-right' ? '0' : 'unset')};
  left: ${({ position }) => (position === 'top-left' || position === 'bottom-left' ? '0' : 'unset')};
  bottom: ${({ position }) => (position === 'bottom-left' || position === 'bottom-right' ? '0' : 'unset')};
  border-radius: 2px;
  z-index: 1;
`;
